import P2Regular from 'components/typography/P2Regular';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the external Id.
 */
export default function ExternalIdColumn({ data: { externalId } }: { data: FaultRow }) {
  return <P2Regular lineClamp={3}>{externalId}</P2Regular>;
}
